var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMy = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2727 2.5H4.72727C3.22364 2.5 2 3.72364 2 5.22727V19.7727C2 21.2764 3.22364 22.5 4.72727 22.5H19.2727C20.7764 22.5 22 21.2764 22 19.7727V5.22727C22 3.72364 20.7764 2.5 19.2727 2.5ZM8.36364 10.6818C8.36364 8.67364 9.99182 7.04545 12 7.04545C14.0082 7.04545 15.6364 8.67364 15.6364 10.6818V12.5C15.6364 14.5082 14.0082 16.1364 12 16.1364C9.99182 16.1364 8.36364 14.5082 8.36364 12.5V10.6818ZM18.3636 19.7727H5.63636C4.76273 19.7727 4.39182 18.6609 5.09091 18.1364L7.86909 16.0527C8.87 17.2155 10.3491 17.9545 12 17.9545C13.6509 17.9545 15.1291 17.2145 16.1309 16.0527L18.9091 18.1364C19.6082 18.6609 19.2373 19.7727 18.3636 19.7727Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/my.1b1bb51ba398b9e0051f7c53c698cb61.svg";